var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.225 7.92516C17.225 7.76683 17.1667 7.6085 17.0417 7.4835C16.8 7.24183 16.4 7.24183 16.1583 7.4835L10.725 12.9168C10.325 13.3168 9.67502 13.3168 9.27502 12.9168L3.84168 7.4835C3.60002 7.24183 3.20002 7.24183 2.95835 7.4835C2.71668 7.72516 2.71668 8.12516 2.95835 8.36683L8.39168 13.8002C8.81668 14.2252 9.39168 14.4668 10 14.4668C10.6083 14.4668 11.1833 14.2335 11.6083 13.8002L17.0417 8.36683C17.1583 8.24183 17.225 8.0835 17.225 7.92516Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.be452caf8a272e58323e80c593642e37.svg";
export { ForwardRef as ReactComponent };